import './App.css';
import {useState, useEffect, createContext, useRef} from 'react';
import jwtDecode from 'jwt-decode';
import {Route, Routes, useLocation} from 'react-router-dom';
import Navbar from './Navbar.js';
import KBForm from '../KB/KBForm.js';
import Item from "../Item/Item.js";
import {Alert, Box} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import * as React from "react";
import Loader from "../Loaders/LocalLoader.js";
import {APIEndpoints} from "../APIServices/APIEndpoints";
import {
    isMobile, is_localhost, getQueryParamValue, validateFromAppDomain, appendToUrl, removeFromUrl, redirectToBase,
    parseKBSubdomain, isAutoinstall, is_on_premises, fromWebBot
} from "./utils.js";
import { alpha } from '@mui/material/styles';
import {KBListPage} from "../KB/KBListPage.js";
import {UserProfile} from "../User/Profile";
import {UserWallets} from "../User/Billing";
import {Whitescreen} from "./Whitescreen.js";
import Snackbar from "@mui/material/Snackbar";
import {ShareChat} from "../Chat/ShareChat.js";
import {APIRequest} from "../API/APIRequest.js";
import {LeftMenu} from "./LeftMenu";
import {FixedBottomNavigation} from "./FixedBottomNavigation";
import {AppCenter} from "../KB/AppCenter";
import {AppInstall} from "../KB/Install/AppInstall";
import {getUserProfile, fetchKBJWT, PHONE_VERIFICATION_STATUS} from "../API/User";
import {PrivacyPolicy} from "../Public/PrivacyPolicy";
import {TermsOfUse} from "../Public/TermsOfUse";
import {PhoneVerification} from "../Components/PhoneVerification";
import {initWS} from "../API/Websocket";
import {getAccountBalances} from "../API/Ledger";
import {getKB} from "../API/KB/KBAPI";
import {decryptKBItem, decryptKBItemIfEncrypted} from "./cryptoUtils";
import {
    chatActionRequest,
    deleteOrphanedUnreadMessages,
    getChat,
    listChats, ON_PREMISES_CHAT_MODELS, setOnPremisesChatModelsConst,
    setOnPremisesChatURL
} from "../API/chatAPI";
import {createHandleWebsocketMessages, fetchUnreadMessages} from "./AppActions";
import {initialPlay, takeTheSoundLock} from "../Media/utils";
import {spaLogger} from "../API/APP/SPALoggerAPI";
import {InstallCLI} from "../APIServices/InstallCLI";
import {Pricing} from "../APIServices/Pricing";
import LocalLoader from "../Loaders/LocalLoader.js";
import ItemType from "../Item/ItemType";
import ReactGA from 'react-ga4';
import {GAPurchase} from "./GA";
import {getApp} from "../API/APP/AppAPI";
import {AppPenalty} from "./AppPenalty";
import {AuthScreen} from "./AppAuthScreen";
import {Logout} from "./AppLogout";
import {createNavigateToChat} from "./AppHelpers";
import {ChatModels} from "../constants";
import {isSharedChat} from "../utils";
if (!is_on_premises) ReactGA.initialize('G-SG3D284F5J');

export const AlertContext = createContext();
export const APIContext = createContext();
export const drawerWidth = 300;

if (!getQueryParamValue('disableWS')) initWS()
let logoutPressed = false;
let deletedOrphanedChatIds = {};
let initialClick = false;
function App() {
    const [isCheckingLogin, setIsCheckingLogin] = useState(true);
    const [client, setClient] = useState({});
    const [isWhitePage, setWhitePage] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [network, setNetwork] = useState([]);
    const [systemAlert, setSystemAlert] = useState({});
    const [APIData, setAPIData] = useState({ kbs: {}, KBData: {}});
    const [open, setOpen] = useState(!isMobile);
    const [tokenExpired, setTokenExpired] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const pathSegments = location.pathname.split('/');
    const firstPathSegment = pathSegments && pathSegments[1];
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [userProfile, setUserProfile] = useState({});
    const [termsAccepted, setTermsAccepted] = useState(true);
    const [subscribed, setSubscribed] = useState(true);
    const [showError, setShowError] = useState(false);
    const [loadingBalances, setLoadingBalances] = useState(false);
    const [balances, setBalances] = useState([]);
    const [kbData, setKBData] = useState(null);
    const [chatId, setChatId] = useState(window?.location?.pathname?.match?.(/\/chat\/([\w-]+)/)?.[1]);
    const [kbChats, setKBChats] = useState(null);
    const [ChatData, setChatData] = useState(null);
    const [isStreaming, setIsStreaming] = useState(false);
    const [KBKeyIsSet, setKBKeyIsSet] = useState(false);
    const [unreadMessages, setUnreadMessages] = useState({});
    const [penalty, setPenalty] = useState(null);
    const [appToInstall, setAppToInstall] = useState({});
    const [renderSettings, setRenderSettings] = useState({
        disableEmojiButton: false,
        disableShareButton: false,
        disableCopyButton: false,
        disableChatAvatar: false,
        disableSentLabel: false,
        disableMobileRightButton: false,
        disableMobileLeftButton: false,
        disableTotalMessagesLabel: false,
        disableContextItems: false,
        disableBalanceView: false,
        // chatContainerHeight: window.innerHeight - 370,
        // instructionSuffix: ''
    });
    const [onPremisesChatModels, setOnPremisesChatModels] = useState(null);

    const previousChatIdRef = useRef(null);

    const path = window?.location?.pathname;

    let fromInstallAppId;

    if (path?.startsWith('/install/') && path?.split('/')?.[2]) {
        fromInstallAppId = path?.split('/')?.[2]
    }

    useEffect(() => {
        if (is_on_premises && onPremisesChatModels === null) {
            let currentOrigin = window.location.origin;

            // remove the {kbId}.apps subdomain prefix from the ChatAPI url
            currentOrigin = currentOrigin.replace(/^https?:\/\/[^.]+\.apps\./, 'http://');

            // Construct the new API URL with the specified port
            const onPremisesAPIURL = `${currentOrigin.split(':')[0]}:${currentOrigin.split(':')[1]}:38594`;
            chatActionRequest({ action: 'getOnPremisesChatModels'}, undefined, onPremisesAPIURL).then(data => {
                if (data?.data && Object.keys(data.data)?.length) {
                    setOnPremisesChatURL(onPremisesAPIURL)
                    const models = window.enableCloudModels === "true" ? {...ChatModels, ...data?.data} : data?.data;
                    setOnPremisesChatModelsConst(models)
                    setOnPremisesChatModels(models)

                } else {
                    setOnPremisesChatModels(false) // no OnPremisesChatAPI available
                }
            }).catch(() => {
                setOnPremisesChatModels(false) // no OnPremisesChatAPI available
            });
        }
    }, [onPremisesChatModels]);

    useEffect(() => {
        if (!fromInstallAppId) return;
        getApp(fromInstallAppId, 'publicAccess').then(data => {
            setAppToInstall(data)
        })
    }, []);

    useEffect(() => {
        // @Stop GA for kbSubdomains
        if (parseKBSubdomain()) return;
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, title: document.title });
    }, [location]);

    useEffect(() => {
        if (is_on_premises && onPremisesChatModels === null) return;
        if (!kbChats) return;
        if (!chatId) return setChatData(null);
        if (kbChats.some(chat => chat.chatId === chatId)) {
            if (previousChatIdRef.current === chatId) return;
            getChat(chatId).then((data) => {
                if (!data) return;
                if (data?.title) data.title = decryptKBItemIfEncrypted(data.title);
                if (data?.chatInstructions) data.chatInstructions = decryptKBItemIfEncrypted(data.chatInstructions);
                setChatData(data);
                previousChatIdRef.current = chatId;
            });
        } else {
            setChatData(null);
        }
    }, [chatId, kbChats, onPremisesChatModels])


    useEffect(() => {
        if (is_on_premises && onPremisesChatModels === null) return;
        // Detect orphaned unreadMessages
        if (kbChats && Object.keys(unreadMessages)?.length) {

            // kbChat.chatId
            let unreadChatIds = Object.keys(unreadMessages);
            for (let i = 0; i < unreadChatIds.length; i++) {
                const orphaned = !kbChats.some(o => o.chatId === unreadChatIds[i])

                if (orphaned && !deletedOrphanedChatIds?.[unreadChatIds?.[i]]) {
                    deletedOrphanedChatIds[unreadChatIds[i]] = true;
                    spaLogger(`deleteOrphanedUnreadMessages ${unreadChatIds[i]}`)
                    console.log(`deleteOrphanedUnreadMessages ${unreadChatIds[i]}`)
                    deleteOrphanedUnreadMessages(unreadChatIds[i]);
                    fetchUnreadMessages({setUnreadMessages})
                }

            }
        }

    }, [unreadMessages, kbChats, onPremisesChatModels]);

    let kbIdAsSubdomain, appsPrefix;

    const kbSubdomain = parseKBSubdomain();
    const navigateToChat = createNavigateToChat({kbSubdomain, setChatId, navigate})

    if (kbSubdomain) {
        kbIdAsSubdomain = kbSubdomain.kbIdAsSubdomain;
        appsPrefix = kbSubdomain.appsPrefix;
    }

    useEffect(() => {
        if (is_on_premises && onPremisesChatModels === null) return;

        if (kbSubdomain && kbIdAsSubdomain && KBKeyIsSet) {
            listChats().then(data => setKBChats(data?.data ? data.data : []))
            fetchUnreadMessages({setUnreadMessages});
        }
    }, [KBKeyIsSet, onPremisesChatModels]);

    useEffect(() => {
        if (kbSubdomain) return; // Just to make sure

        const token = localStorage.getItem("clientJWT");
        if (!token) return;
        getUserProfile().then((data) => {
            setUserProfile(data);
        })
    }, [client]);

    useEffect(() => {
        const accountPenalty = balances?.find(o => o.penalty)?.penalty;
        let myPenalty;
        if (accountPenalty) {
            myPenalty = accountPenalty
        }
        else if (kbSubdomain && kbData?.penalty) {
            myPenalty = kbData?.penalty
        } else if (userProfile?.penalty) {
            myPenalty = userProfile?.penalty
        }

        if (!myPenalty) return; // expired

        const {createdAt, details, expiredAt, level, reason} = myPenalty;
        if (expiredAt && +new Date() > expiredAt) return; // skip expired penalty

        if (level === 1 && +new Date() > (parseInt(createdAt) + 60 * 1000)) return; // skip any warnings older the 1 minute
        if (localStorage.getItem('AcknowledgeWarning') === createdAt?.toString()) return;

        setPenalty(myPenalty)
    }, [userProfile, kbData, balances]);


    const fetchBalances = ({withLoaders = true, accountId, walletPrivateKey, walletPublicKey}) => {
        if (withLoaders) {
            setLoadingBalances(true);
        }

        if (accountId) {
            getAccountBalances(accountId, walletPrivateKey, walletPublicKey)
                .then((balances) => {
                    setBalances(balances);
                    if (withLoaders) setLoadingBalances(false);
                });
        }
    }

    const fetchKBBalances = (kbData) => fetchBalances({
        withLoaders: false,
        walletPrivateKey: decryptKBItem(kbData?.walletPrivateKey),
        walletPublicKey: kbData?.walletPublicKey,
        accountId: kbData?.accountId
    });

    const fetchUserBalances = (userProfile) => fetchBalances({withLoaders: false, ...userProfile});

    useEffect(() => {
        if (kbSubdomain) {
            getKB().then(data => {
                setKBData(data);
                fetchKBBalances(data);
            })
        }
    }, []);

    useEffect(() => {
        const tab = location.search && new URLSearchParams(location.search).get('tab');
        const isSubdomain = parseKBSubdomain();

        const isChat = isSubdomain && (location.pathname === '/' || location.pathname?.startsWith('/chat')) &&
            (!tab || tab === 'chat') && !isSharedChat;

        if (isChat) {
            document.body.classList.add('chat-container-body');
        } else {
            document.body.classList.remove('chat-container-body');
        }
    }, [location]);

    useEffect(() => {
        const handleWebsocketMessage = createHandleWebsocketMessages({
            kbSubdomain, kbData, fetchKBBalances, userProfile, fetchUserBalances, navigateToChat, setKBChats, chatId,
            penalty, setPenalty
        });

        window.addEventListener('onWebsocketMessage', handleWebsocketMessage);

        return () => {
            window.removeEventListener('onWebsocketMessage', handleWebsocketMessage);
        };
    }, [userProfile, kbData, chatId]);

    useEffect(() => {
        if (userProfile?.accountId) {
            fetchUserBalances(userProfile);
        }
    }, [userProfile]);

    /***
     * Load servers
     */
    useEffect(() => {

        if (0 && is_localhost) {
            APIRequest('get', 'http://0.0.0.0:8080/state', null, null, {optimistic: true}).then((data) => {
                if (!data?.data) return;
                setNetwork((prevSubnets) => {
                    return [
                        ...prevSubnets.filter(o => o?.subnet !== 'localhost'),
                        { subnet: 'localhost', servers: [{url: 'http://0.0.0.0:8080/', ...data.data}]}
                    ]
                })
            });
        }

    }, []);
    //
    useEffect(() => {
        const kbToken = getQueryParamValue('kbToken');
        const bonus_button_click_index = getQueryParamValue('bonus_button_click_index');
        const purchase_success = getQueryParamValue('purchase_success');

        if (kbToken) {
            // LoginKB Step 3 storing the kbToken on the subdomains local storage
            loginKB(kbToken)
            window.location.href = removeFromUrl(window.location.href, 'kbToken');
        }
        else if (purchase_success) {
            const session_id = getQueryParamValue('session_id');
            const amount = parseInt(getQueryParamValue('amount'));
            // first time on this page
            if (session_id && amount) {
                GAPurchase(session_id, amount)
            }
            navigate(new URL(window.location.href).pathname);
            setSystemAlert({msg: `You've successfully added $${amount} in credits to your account.`, type: 'success', duration: 10000});
        }
        else if (bonus_button_click_index) {
            navigate(new URL(window.location.href).pathname);
        }

    }, []);


    useEffect(() => {
        window.addEventListener('logout', logout);
        return () => window.removeEventListener('logout', logout)
    }, []);


    /***
     * ERROR HANDLERS
     */

    useEffect(() => {
        const requestTimeout = (e) => {
            setSystemAlert({msg: e?.detail?.message, type: 'error', duration: 6000});
        };

        window.addEventListener('requestTimeout', requestTimeout);
        return () => window.removeEventListener('requestTimeout', requestTimeout)
    }, []);

    useEffect(() => {
        const sizeTooLarge = (e) => {
            setSystemAlert({msg: 'Request size is too large (max size 6MB)', type: 'error', duration: 6000});
        };

        window.addEventListener('sizeTooLarge', sizeTooLarge);
        return () => window.removeEventListener('sizeTooLarge', sizeTooLarge)
    }, []);

    useEffect(() => {
        const networkError = (e) => {
            setSystemAlert({msg: 'Request Failed', type: 'error', duration: 6000});
        };

        window.addEventListener('networkError', networkError);
        return () => window.removeEventListener('networkError', networkError)
    }, []);

    useEffect(() => {
        const internalServerError = (e) => {
            const errorMsg = e.detail.message;
            setSystemAlert({msg: errorMsg, type: 'error', duration: 10000});
        };

        window.addEventListener('internalServerError', internalServerError);
        return () => window.removeEventListener('internalServerError', internalServerError)
    }, []);

    useEffect(() => {
        const handleUnauthorizedError = () => {
            console.log('unauthorizedError', logoutPressed)
            setSystemAlert({msg: "Session expired, please login again.", type: 'error', duration: 3000});
            if (parseKBSubdomain()) {
                redirectToBase(logoutPressed);
                return;
            }
            setTokenExpired(true);
        };
        window.addEventListener('unauthorizedError', handleUnauthorizedError);
        return () => window.removeEventListener('unauthorizedError', handleUnauthorizedError)
    }, []);

    /***
     * ERROR HANDLERS END
     */

    // // #resize1
    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if(location.pathname.includes('/apps/') && location.pathname.includes('/item/')) {
            setWhitePage(true);
        } else {
            setWhitePage(false);
        }
    }, [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [systemAlert]);

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const isLogged = () => {
        return Object.keys(client).length > 0;
    }

    const isLoggedInKB = () => {
        const JWT = localStorage.getItem('kbJWT');
        const kbTokenData = JWT && jwtDecode(JWT);

        if (kbTokenData?.kbId) {
            return true;
        } else {
            localStorage.removeItem('kbJWT');
        }
    }

    function loginKB(JWT) {
        const kbTokenData = JWT && jwtDecode(JWT);

        if (kbTokenData?.kbId) {
            localStorage.setItem('kbJWT', JWT);
        } else {
            // remove invalid token
            localStorage.removeItem('kbJWT');
        }
    }

    function logoutKB(e) {
        localStorage.removeItem('kbJWT')
    }

    useEffect(() => {
        const fromShared = getQueryParamValue('fromShared');
        const fromApp = getQueryParamValue('fromApp');
        // LoginKB Step 2 capture fromApp redirected from kb subdomain to fetch kbToken and redirect back to subdomain
        if (fromApp && validateFromAppDomain(fromApp)) {
            const executionCount = parseInt(sessionStorage.getItem('executionCount')) || 0;
            const startTime = parseInt(sessionStorage.getItem('startTime')) || Date.now();

            if (Date.now() - startTime > 30000) {
                sessionStorage.setItem('executionCount', 1);
                sessionStorage.setItem('startTime', Date.now());
            } else if (executionCount >= 7) {
                sessionStorage.setItem('executionCount', 0);
                spaLogger('fromApp loop')
                console.log('Execution blocked: Too many attempts within a minute');
                return;
            } else {
                sessionStorage.setItem('executionCount', executionCount + 1);
            }

            const fromAppHostname = new URL(fromApp).hostname
            const {kbIdAsSubdomain} = parseKBSubdomain(fromAppHostname);

            const clientJWT = localStorage.getItem("clientJWT");
            // if there is not clientJWT logout from the main app
            if(!clientJWT) return logout()

            fetchKBJWT(kbIdAsSubdomain, !!fromShared).then(data => {
                const kbToken = data?.data?.kbToken;
                if (kbToken) {
                    window.location.href = appendToUrl(fromApp, 'kbToken', kbToken);
                } else {
                    console.log('Unable to fetch kbToken')
                }
            })
        }
    }, [client]);

    useEffect(() => {
        const isSubdomain = parseKBSubdomain();
        const loginFunction = isSubdomain ? loginKB : login;
        const logoutFunction = isSubdomain ? logoutKB : logout;

        const token = isSubdomain
            ? localStorage.getItem('kbJWT')
            : localStorage.getItem("clientJWT");

        if (token) {
            try {
                const decoded = jwtDecode(token);
                const currentTime = new Date().getTime() / 1000;

                if (decoded.exp > currentTime) {
                    loginFunction(token);
                } else {
                    logoutFunction();
                }
            } catch (error) {
                logoutFunction();
            }
        }
        setIsCheckingLogin(false);
    }, []);

    function login(JWT, fromTokenExpired, newUser, fromInstallAppId) {
        setClient(jwtDecode(JWT));
        localStorage.setItem("clientJWT", JWT);

        if (getQueryParamValue('from_cli')) {
            const img = new Image();
            img.src = 'http://localhost:38591/capture-token?clientJWT=' + encodeURIComponent(JWT);
            img.onload = () => {
                console.log('Token sent to CLI tool successfully.');
            };
            img.onerror = (error) => {
                console.error('Error sending token to CLI tool:', error);
            };
        }

        if (fromInstallAppId) {
            const searchParams = new URLSearchParams(window.location.search);
            const queryString = searchParams.toString();
            navigate('/install/' + encodeURIComponent(fromInstallAppId) + (queryString ? '?' + queryString : ''));
            return;
        }

        if (path.startsWith('/signin') || path.startsWith('/signup')) {
            navigate('/dashboard');
            // navigate('fromApp/');
        }
    }

    function logout(e) {
        if (parseKBSubdomain()) {
            logoutPressed = e?.fromLogoutButton;
            localStorage.removeItem('kbJWT');
            redirectToBase(logoutPressed);
        } else {
            logoutPressed = e?.fromLogoutButton;
            setClient({});
            localStorage.removeItem("clientJWT");
        }

        // window.location.reload();
    }

    const authScreenParams = {setShowError, termsAccepted, login, subscribed, setTokenExpired, setLoading, path,
        fromInstallAppId, appToInstall, setTermsAccepted, setSubscribed, showError, isLoading};

    if (penalty && (isLogged() || isLoggedInKB())) return <AppPenalty {...{penalty, setPenalty, kbSubdomain, logout}} />

    if (path.startsWith('/share-chat')) {
        const matches = path.match(/\/share\-chat\/(\w+)\/(\w+)/);
        return (
            <AlertContext.Provider value={{systemAlert, setSystemAlert}}>
                <ShareChat {...{kbId: matches[1], shareId: matches[2]}} />
            </AlertContext.Provider>
        )
    } else if (path.startsWith('/privacy-policy')) {
        return <PrivacyPolicy />
    } else if (path.startsWith('/terms-of-use')) {
        return <TermsOfUse />
    } else if (isCheckingLogin) {
        return <Loader open/>;
    } else if (kbIdAsSubdomain && isLoggedInKB() || !kbIdAsSubdomain && isLogged()) {
        if (getQueryParamValue('ip') && getQueryParamValue('withLogout')) {
            window.location.href = removeFromUrl(window.location.href, 'withLogout')
            logout()
        }

        const phoneNotVerified = [PHONE_VERIFICATION_STATUS.NOT_VERIFIED, PHONE_VERIFICATION_STATUS.IN_PROGRESS]
            .includes(userProfile?.phoneVerificationStatus)

        const tabStyle = {
            '&.Mui-selected': {
                backgroundColor: alpha('#fff', 0.06),
            },
            '&.Mui-selected:hover': {
                backgroundColor: alpha('#fff', 0.1),
            },
        };

        if (typeof systemAlert?.msg !== 'string'){
            delete systemAlert.msg;
        }

        const fromApp = getQueryParamValue('fromApp');
        const onPremisesIsLoading = is_on_premises && onPremisesChatModels === null;
        if (onPremisesIsLoading) return;

        return (<div className="App" onClick={() => {
            // playSound('/static/sound/interface.mp3', 0.1, true)
            if (!initialClick) {
                takeTheSoundLock()
                initialPlay()
                initialClick = true;
            }

        }}>

            {(userProfile && Object.keys(userProfile)?.length === 0) && <LocalLoader timeout={6 * 1000} open={true} />}
            {isStreaming && <LocalLoader timeout={180 * 1000} open={true} color="success" />}
            <LocalLoader blocking={true} timeout={6 * 1000} open={(fromApp && !kbIdAsSubdomain && isLogged())} backgroundColor={'white'} />

            <audio
                id="ttsAudio"
                style={{ position: 'absolute', width: 0, height: 0, visibility: 'hidden' }}
                controls
            ></audio>
            <APIContext.Provider value={{APIData, setAPIData}}>
                <Navbar onLogout={logout} {...{kbChats, chatId, setKBChats, isStreaming, navigateToChat,
                    unreadMessages, balances, open, setOpen, userProfile, setUserProfile,loadingBalances, kbSubdomain,
                    renderSettings, ChatData, setChatData
                }} />
                {tokenExpired && <div style={{position: "absolute", zIndex: 20000}}>{AuthScreen({...authScreenParams, fromTokenExpired: true})}</div>}

                {isMobile
                    ? (!kbIdAsSubdomain && <FixedBottomNavigation />)
                    : <LeftMenu {...{open, drawerWidth, handleDrawerClose, firstPathSegment, tabStyle, network, navigate,
                        pathSegments, kbSubdomain, kbChats, setKBChats, navigateToChat, isStreaming, unreadMessages,
                        loadingBalances, balances, ChatData, setChatData
                    }}/>}

                <Box
                    sx={{
                        backgroundColor: theme => theme.palette.background.default,
                        minHeight: windowHeight - 136, // 136 is magic number to avoid scrollbar
                        flexGrow: 1,
                        p: 3,
                        // marginTop: 17,
                        paddingTop: isMobile && !kbSubdomain ? '30px' : 14,
                    }}
                >

                    <Box sx={{
                        transition: 'margin-left 0.2s', ...(open && {
                            marginLeft: `${drawerWidth}px`,
                        })
                    }}
                    >

                        <AlertContext.Provider value={{systemAlert, setSystemAlert}}>
                            <Snackbar
                                style={{zIndex: 10000}}
                                autoHideDuration={systemAlert?.duration || 6000}
                                anchorOrigin={{ vertical: systemAlert?.vertical || 'top', horizontal: systemAlert?.horizontal || 'right' }}
                                open={!!systemAlert?.msg}
                                onClose={(event, reason) => {
                                    if (reason === 'clickaway' && systemAlert?.disableClickaway ) {
                                        return; //
                                    }
                                    setSystemAlert({ ...systemAlert, msg: '' });
                                }}
                            >
                                {systemAlert?.msg && (
                                    <Alert
                                        onClose={systemAlert.onClose !== undefined ? systemAlert.onClose : (prev) => setSystemAlert({ ...prev, msg: '' })}
                                        severity={systemAlert.type}
                                        sx={{ width: '100%', minWidth: '200px', marginTop: systemAlert?.marginTop || '50px' }}
                                    >
                                        {systemAlert?.multiline && typeof systemAlert?.msg === 'string' ? (
                                            systemAlert.msg.split('\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index !== systemAlert.msg.split('\n').length - 1 && <br />}
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            systemAlert.msg
                                        )}
                                    </Alert>
                                )}
                            </Snackbar>

                            {phoneNotVerified && userProfile && !isAutoinstall() && !getQueryParamValue('selectedService') &&
                                <PhoneVerification userProfile={userProfile} setUserProfile={setUserProfile} />}

                            { kbIdAsSubdomain && appsPrefix && userProfile
                                ?
                                    path === '/' && <KBForm {...{
                                        open, unreadMessages, setUnreadMessages, setKBKeyIsSet, kbIdAsSubdomain,
                                    network, userProfile, chatId, navigateToChat, kbChats, setKBChats, setIsStreaming,
                                    isStreaming, renderSettings, setRenderSettings, ChatData, setChatData
                                    }} /> ||
                                    path.match(/\/chat\/([\w-]+)/) &&
                                    <KBForm {...{
                                        open, unreadMessages, setUnreadMessages, setKBKeyIsSet, kbIdAsSubdomain,
                                        network, userProfile, chatId, navigateToChat, kbChats, setKBChats,
                                        setIsStreaming, isStreaming, renderSettings, setRenderSettings,
                                        ChatData, setChatData
                                    }} /> ||
                                    path === '/new-item' && <Item {...{kbIdAsSubdomain}} /> ||
                                    path === '/new-item-type' && <ItemType {...{kbIdAsSubdomain}} /> ||
                                    path.match(/\/edit\-item\-type\/(\w+)/) && <ItemType {...{kbIdAsSubdomain, injectedItemType: path.match(/\/edit-item\-type\/(\w+)/)[1]}} /> ||
                                    path.match(/\/edit\-item\/(.*)/) && <Item {...{kbIdAsSubdomain, injectedItemId: path.match(/\/edit-item\/(.*)/)[1]}} />
                                :
                                    <Routes>
                                        <Route exact path="/" element={<KBListPage hideIfEmpty={true} />}/>
                                        <Route exact path="/dashboard" element={<KBListPage hideIfEmpty={true} />}/>
                                        <Route exact path="/profile" element={<UserProfile client={client} setClient={setClient} />}/>
                                        <Route exact path="/billing" element={<UserWallets userProfile={userProfile} />}/>
                                        <Route path="/create" element={userProfile && Object.keys(userProfile)?.length
                                            && <KBForm {...{setLoading, network, userProfile, newKB:true, navigateToChat,
                                                setIsStreaming, isStreaming, ChatData, setChatData}}  />}/>
                                        <Route exact path="/app-center" element={<AppCenter />}/>
                                        <Route exact path="/install/:appId" element={userProfile && Object.keys(userProfile)?.length &&
                                            <AppInstall userProfile={userProfile} phoneNotVerified={phoneNotVerified} />}/>
                                        <Route exact path="/api/services" element={<APIEndpoints userProfile={userProfile}  />}/>
                                        <Route exact path="/api/cli" element={<InstallCLI userProfile={userProfile}  />}/>
                                        <Route exact path="/services-pricing" element={<Pricing />}/>

                                        <Route exact path="/logout" element={<Logout />} />
                                        {/* Add more routes here */}
                                    </Routes>
                            }

                        </AlertContext.Provider>

                    </Box>

                </Box>
                {/* Allow some space to scroll under the bottom menu */}
                {isMobile && !kbIdAsSubdomain && <Box style={{ height: 40 }}></Box>}
                <Whitescreen open={isWhitePage} />
            </APIContext.Provider>
        </div>);
        // app not logged
    } else if (!isLoggedInKB() && parseKBSubdomain()) {
        // LoginKB Step 1 from kbSubdomain redirect back to base URL with fromApp param
        redirectToBase(logoutPressed);
    } else if (!parseKBSubdomain()) {
        if (getQueryParamValue('ip') && getQueryParamValue('withLogout')) {
            window.location.href = removeFromUrl(window.location.href, 'withLogout')
        }
        return AuthScreen({...authScreenParams});
    }
}




export default App;
